import PropTypes from 'prop-types';

export const viewFilterShape = PropTypes.shape({
  label: PropTypes.string,
  filterFn: PropTypes.func
});

export const sortFilterShape = PropTypes.shape({
  label: PropTypes.string,
  sortFn: PropTypes.func
});

export const filterTypeShape = PropTypes.shape({
  currentFilter: PropTypes.oneOfType([sortFilterShape, viewFilterShape]),
  defaultFilter: PropTypes.oneOfType([sortFilterShape, viewFilterShape]),
  filterCollection: PropTypes.arrayOf(PropTypes.oneOfType([sortFilterShape, viewFilterShape])),
  handleDropdownClose: PropTypes.func,
  openConst: PropTypes.string,
  onChange: PropTypes.func,
  openStatus: PropTypes.bool,
  toggleDropdown: PropTypes.func
});
